import { Box } from '@gemini/core';
import { TextField } from '@gemini/ui';
import Popover from '@mfe-presentation/components/Popover/Popover';
import { IFieldProps } from '@mfe-types/field';

const TextFieldWrapper = ({ field, texts, styles }: Required<IFieldProps<any, any>>) => {
    const getAriaLabel = () => {
        if (texts.ariaLabel) {
            return texts.ariaLabel?.text;
        } else if (texts.label) {
            return texts.label;
        } else {
            return field.name;
        }
    };

    return (
        <Box {...styles}>
            {texts.tooltip && (
                <Popover
                    name={`${field.name}Popover`}
                    label={texts.label}
                    iconButtonAriaDescribedby={`${field.name}-description`}
                >
                    <Box id={`${field.name}-description`} typography="typography.body.14.regular">
                        {texts.tooltip}
                    </Box>
                </Popover>
            )}
            <TextField
                {...field}
                isFullWidth
                suffix={texts.suffix}
                label={texts.tooltip ? '' : texts.label ?? ''} // the warning about providing a visibile label / aria-label is not accurate (currently handled by Popover component)
                aria-label={getAriaLabel()}
                testId={field.name}
            />
        </Box>
    );
};

export default TextFieldWrapper;
